
import Vue from "vue";
import moment from "moment";
import {
  listMandrillRejects,
  deleteMandrillReject,
  resubscribeUser,
  MandrillRejectEntry
} from "@/api";

export default Vue.extend({
  name: "SpamList",
  data() {
    return {
      searchEmail: "",
      includeExpired: false,
      loading: false,
      removing: false,
      removingEmail: "" as string,
      rejects: [] as MandrillRejectEntry[],
      removeDialog: false,
      pendingRemove: null as MandrillRejectEntry | null,
      resubscribeDialog: false,
      resubscribing: false,
      resubscribingEmail: "" as string,
      pendingResubscribe: null as MandrillRejectEntry | null,
      headers: [
        { text: "Recipient", value: "email" },
        { text: "Reason", value: "reason" },
        { text: "Last Event", value: "last_event_at" },
        { text: "Expiration", value: "expires_at" },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          width: "190px"
        }
      ]
    };
  },
  methods: {
    async loadRejects() {
      this.loading = true;
      try {
        const email = this.searchEmail ? this.searchEmail.trim() : undefined;
        this.rejects = await listMandrillRejects(email, this.includeExpired);
      } catch (error) {
        console.error("Failed to load spam list", error);
        this.rejects = [];
      } finally {
        this.loading = false;
      }
    },
    formatMandrillDate(value?: string) {
      if (!value) return "—";
      const parsed = moment(value);
      return parsed.isValid() ? parsed.format("YYYY-MM-DD HH:mm") : value;
    },
    confirmRemove(item: MandrillRejectEntry) {
      this.pendingRemove = item;
      this.removeDialog = true;
    },
    confirmResubscribe(item: MandrillRejectEntry) {
      this.pendingResubscribe = item;
      this.resubscribeDialog = true;
    },
    async doResubscribe() {
      if (!this.pendingResubscribe) return;
      this.resubscribing = true;
      this.resubscribingEmail = this.pendingResubscribe.email;
      try {
        const result = await resubscribeUser(
          this.pendingResubscribe.email,
          this.pendingResubscribe.subaccount
        );
        this.rejects = this.rejects.filter(
          r => r.email !== this.pendingResubscribe!.email
        );
        this.resubscribeDialog = false;
        this.pendingResubscribe = null;
        this.$store.commit("callSnackbar", {
          visible: true,
          text: `Re-subscribed ${result.userEmail}.`,
          color: "#13CA82"
        });
      } catch (error) {
        const message =
          error instanceof Error ? error.message : "Re-subscribe failed";
        this.$store.commit("callSnackbar", {
          visible: true,
          text: `Could not re-subscribe: ${message}`,
          color: "#FB7672"
        });
      } finally {
        this.resubscribing = false;
        this.resubscribingEmail = "";
      }
    },
    async removeReject() {
      if (!this.pendingRemove) return;
      this.removing = true;
      this.removingEmail = this.pendingRemove.email;
      try {
        await deleteMandrillReject(
          this.pendingRemove.email,
          this.pendingRemove.subaccount
        );
        this.rejects = this.rejects.filter(
          r => r.email !== this.pendingRemove!.email
        );
        this.removeDialog = false;
        this.pendingRemove = null;
      } catch (error) {
        console.error("Failed to remove reject", error);
      } finally {
        this.removing = false;
        this.removingEmail = "";
      }
    }
  }
});
